import React from "react";

const CamOff = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-on-shout"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35594 6.51465L12.1588 11.8125H18.8442C19.5173 11.8125 20.063 12.3582 20.063 13.0312V16.9349C20.1046 16.7223 20.2309 16.5238 20.4418 16.3972L26.84 12.5554C27.3816 12.2302 28.0708 12.6203 28.0708 13.252V20.9355C28.0708 21.5672 27.3816 21.9573 26.84 21.6321L20.4418 17.7903C20.2309 17.6637 20.1046 17.4652 20.063 17.2526V19.0288L28.5361 26.7646L27.1802 28.2498L19.9566 21.6549C19.9554 21.6577 19.9541 21.6605 19.9528 21.6634L9.16295 11.8125H9.17608L5 7.99984L6.35594 6.51465ZM6.68341 11.9363C6.27894 12.1346 6.00047 12.5504 6.00047 13.0312V21.1562C6.00047 21.8293 6.54613 22.375 7.21922 22.375H18.1171L6.68341 11.9363Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default CamOff;
